import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import NoteTemplatesFilter from "./NoteTemplatesFilter";
import { getNoteTemplateCategoriesEnhancer, getCurrentPermissionsEnhancer } from "../enhancer";
import { noteTemplatesFilterSetArchived, noteTemplatesFilterSetCategories, noteTemplatesFilterSetForAgents, noteTemplatesFilterSetForStudents, noteTemplatesFilterSetRestricted, noteTemplatesFilterSetTags, noteTemplatesFilterSetTemplateTypes, noteTemplatesFilterArchive, noteTemplatesFilterCategories, noteTemplatesFilterForAgents, noteTemplatesFilterForStudents, noteTemplatesFilterRestricted, noteTemplatesFilterTags, noteTemplatesFilterTemplateTypes } from '@applyboard/ab-common';
import { buildObjectListCached } from "../../../util/redux";
import memoized from "../../../util/memoized";
var mapCategories = memoized(function (list) {
  return list.map(function (e) {
    return {
      label: e,
      value: e
    };
  });
});
var getCategoriesOptionList = function getCategoriesOptionList(state) {
  try {
    var list = state.noteTemplates.categories;
    return mapCategories(list);
  } catch (e) {
    /* intentionally left blank */
  }
  return [];
};
var buildTagsOptionList = buildObjectListCached('tag_definitions');
var mapTags = memoized(function (tags) {
  return tags.map(function (_ref) {
    var id = _ref.id,
      name = _ref.name;
    return {
      value: id,
      label: name
    };
  });
});
var getTagsOptionList = function getTagsOptionList(state) {
  try {
    var tags = buildTagsOptionList(state);
    return mapTags(tags);
  } catch (e) {
    /* intentionally left blank */
  }
  return [];
};
var enhancer = compose(lifecycle({
  componentDidMount: function componentDidMount() {
    this.props.noteTemplateCategories.length === 0 && this.props.getNoteTemplateCategories();
  }
}));
var mapStateToProps = createStructuredSelector({
  categories: getCategoriesOptionList,
  filter_archived: noteTemplatesFilterArchive,
  filter_categories: noteTemplatesFilterCategories,
  filter_for_agents: noteTemplatesFilterForAgents,
  filter_for_students: noteTemplatesFilterForStudents,
  filter_restricted: noteTemplatesFilterRestricted,
  filter_tags: noteTemplatesFilterTags,
  filter_template_types: noteTemplatesFilterTemplateTypes,
  tags: getTagsOptionList
});
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleArchivedChange: function handleArchivedChange(archived) {
      return dispatch(noteTemplatesFilterSetArchived(archived));
    },
    handleCategoryChange: function handleCategoryChange(categories) {
      return dispatch(noteTemplatesFilterSetCategories(categories));
    },
    handleForAgentsChange: function handleForAgentsChange(value) {
      return dispatch(noteTemplatesFilterSetForAgents(value));
    },
    handleForStudentsChange: function handleForStudentsChange(value) {
      return dispatch(noteTemplatesFilterSetForStudents(value));
    },
    handleRestrictedChange: function handleRestrictedChange(value) {
      return dispatch(noteTemplatesFilterSetRestricted(value));
    },
    handleTagChange: function handleTagChange(tags) {
      return dispatch(noteTemplatesFilterSetTags(tags));
    },
    handleTemplateTypesChange: function handleTemplateTypesChange(types) {
      return dispatch(noteTemplatesFilterSetTemplateTypes(types));
    }
  };
};
export default getNoteTemplateCategoriesEnhancer(getCurrentPermissionsEnhancer(connect(mapStateToProps, mapDispatchToProps)(enhancer(NoteTemplatesFilter))));